import get from 'lodash/get';
import { createSelector } from 'reselect';
import { GIA } from '../../constants/validationFromName';
import validation from '../../services/validation';

export const giaDomainSelector = state => state.gia;

export const giaItemsSelector = createSelector(
  giaDomainSelector,
  subState => subState.items
);

export const giaSelectedSelector = createSelector(
  giaDomainSelector,
  subState => {
    const validationObject = {
      registration_code: subState.registration_code,
      document_number: subState.document_number
    };

    return validation(validationObject, GIA);
  }
);

export const giaRegistrationCodesSelector = createSelector(
  giaItemsSelector,
  subState => subState.map(item => item.registration_code)
);

export const giaDocumentNumbersSelector = createSelector(
  giaItemsSelector,
  subState => subState.map(item => item.document_number)
);

export const giaBlurSelector = createSelector(
  giaDomainSelector,
  subState => subState.blur
);

export const appealSubmitParticipantSelector = createSelector(
  giaSelectedSelector,
  subState => ({
    document_number: get(subState, 'document_number.value', null),
    registration_code: get(subState, 'registration_code.value', null)
  })
);
